import type { TooltipProps } from '@talos/kyoko';
import { Grid, HStack } from '@talos/kyoko';
import { EllipsisBoxWithTooltip } from '@talos/kyoko/src/components/Form/BaseSelect/EllipsisBoxWithTooltip';
import { PredictionOutcomeTag } from '../PredictionMarkets/PredictionOutcomeTag';
import { SymbolHeader } from './SymbolHeader';
import { SymbolSubhead } from './SymbolSubhead';
import type { SymbolDisplayProps } from './types';

const tooltipProps: Partial<TooltipProps> = {
  contentMaxWidth: '800px',
};

export const SymbolDisplay = ({ stacked, ...props }: SymbolDisplayProps) => {
  return (
    <Grid gridTemplateColumns="min-content 1fr" alignItems="center" gap="spacing4">
      <HStack gap="spacing4">
        <SymbolHeader {...props} />
        <PredictionOutcomeTag outcome={props.expressedOutcome} />
      </HStack>
      <EllipsisBoxWithTooltip tooltipProps={tooltipProps}>
        <SymbolSubhead {...props} />
      </EllipsisBoxWithTooltip>
    </Grid>
  );
};
